<template>
  <el-dialog
    id="realTimeTtansDrog"
    v-dialogDrag
    :visible.sync="dialogF"
    :modal="false"
    :close-on-click-modal="false"
    destroy-on-close
    @close="closed"
  >
    <div slot="title" class="dialog-title-box">
      <div class="title-text">{{ topClickInfo.type=='buy'?'闪电买入':'闪电卖出' }}</div>
    </div>
    <RealTimeTrans
      id="transcc_new_NewFooter_tradef_dialog"
      ref="realTimeTrans"
      class="transcc_new_NewFooter_tradef"
      :buy-or-sell="topClickInfo.type"
      :show-d-only="true"
      :close-refresh="true"
    />
  </el-dialog>
</template>
<script>
import { mapGetters } from 'vuex'
import RealTimeTrans from './RealTimeTrans.vue'
export default {
  components: {
    RealTimeTrans
  },
  data() {
    return {
      dialogF: false
    }
  },
  computed: {
    ...mapGetters(['topClickInfo', 'topCLickNum'])
  },
  watch: {
    topCLickNum() {
    }
  },
  methods: {
    showDialog() {
      this.dialogF = true
    },
    closed() {
      this.$emit('closeScaleReal')
    }
  }
}
</script>

<style scoped lang="scss">
/deep/ .transcc_new_NewFooter_left--right{
  width: 0 !important;
}
/deep/ .box .maintrans .content .left{
  height: 260px;
}
#realTimeTtansDrog{
  #middleMargin .transcc_new_NewFooter_left_top{
    flex: 1;
  }
  /deep/ .el-dialog{
    width: 306px;

    background: #000 !important;
    border-radius: 8px;
    border: 1px solid #999999;
    overflow: hidden;
  }
  /deep/ .el-dialog__header{
    height: 30px;
    background-color: #000000;
    border: 0;
    border-bottom: 1px solid #5D5D5D;
    padding: 5px 5px 0 5px;
  }
  /deep/ .el-dialog__headerbtn{
    width: 18px;
    height: 18px;
    top: 7px;
    right: 16px;
    font-size: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  /deep/ .el-dialog__body{
    background-color: #000000;
    border: 0;
    padding: 0px 10px 10px 10px;
    word-break: keep-all;
    height: 357px;
  }
  .dialog-title-box{
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 30px;
    .title-text{
      display: flex;
      justify-content: center;
      align-items: center;
      width: 200px;
      font-size: 14px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #EEEEEE;
      line-height: 20px;
    }
  }
}
</style>
<style lang="scss">
#realTimeTtansDrog{
  // left: 50vw;
  #transcc_new_NewFooter_tradef_dialog{
    .transcc_new_NewFooter_left--left{
      width: 100%;
      // margin-left: -9px;
      .trade-select{
        width: 245px;
        .el-input__inner {
          width: 245px;
        }
      }
      .sty{
        width: 245px;
      }
    }
    .box{
      background: transparent;
    }
    .main{
      min-height: 200px;
    }
  }
}
</style>
